import React from 'react';
import { Check, ChevronRight, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToOferta = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex items-center pt-4 pb-8 overflow-hidden bg-court-gradient" data-id="element-111">
      {/* Background overlay texture */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-112"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-113">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-114">
          {/* Kicker badge */}
          <FadeIn data-id="element-115">
            <span className="inline-flex items-center gap-1.5 bg-neon/10 border border-neon/30 text-neon font-display font-bold text-xs uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-116">
              <Sparkles className="w-3.5 h-3.5" data-id="element-117" /> Edición Pro 2025
            </span>
          </FadeIn>

          {/* Title with neon underline accent */}
          <FadeIn data-id="element-118">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 uppercase" data-id="element-119">
              Tu año de pádel{' '}
              <span className="relative inline-block text-neon" data-id="element-120">
                resuelto
                <motion.span className="absolute left-0 -bottom-1 h-1.5 w-full bg-neon rounded-full origin-left" initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.6,
                delay: 0.5,
                ease: 'easeOut'
              }} data-id="element-121" />
              </span>
            </h1>
          </FadeIn>

          {/* Mockup with subtle float, no badges */}
          <FadeIn delay={0.2} direction="up" data-id="element-122">
            <div className="relative w-full max-w-md mx-auto mb-5" data-id="element-123">
              <div className="absolute inset-0 bg-neon/20 blur-[100px] rounded-full" data-id="element-124"></div>
              <motion.img src="https://cdn.magicpatterns.com/uploads/gfiKSVpLoTceCAZdAGXvNa/Untitled_design.png" alt="Pádel Master Pack Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" animate={{
              y: [0, -8, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-125" />
            </div>
          </FadeIn>

          {/* Subtitle */}
          <FadeIn delay={0.4} data-id="element-126">
            <p className="text-sm md:text-base text-gray-300 mb-5 max-w-xl mx-auto" data-id="element-127">
              El sistema completo que ya está ayudando a cientos de jugadores
              amateur a mejorar su técnica, posicionamiento y estrategia en la
              cancha.
            </p>
          </FadeIn>

          {/* Bullets - compact inline row */}
          <FadeIn delay={0.5} data-id="element-128">
            <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-6 max-w-2xl mx-auto" data-id="element-129">
              {['Mejorá tu técnica', 'Táctica y posicionamiento', 'Ganá más dobles', 'Evitá errores comunes'].map((bullet, idx) => <li key={idx} className="flex items-center gap-1 text-xs md:text-sm font-medium text-gray-200" data-id="element-130">
                  <Check className="text-neon w-3.5 h-3.5 flex-shrink-0" data-id="element-131" />
                  <span data-id="element-132">{bullet}</span>
                </li>)}
            </ul>
          </FadeIn>

          {/* CTA */}
          <FadeIn delay={0.6} data-id="element-133">
            <Button onClick={scrollToOferta} data-id="element-134">
              QUIERO ACCEDER AHORA <ChevronRight className="w-6 h-6" data-id="element-135" />
            </Button>
          </FadeIn>
        </div>
      </div>
    </section>;
}